import { RiskAssessmentReportTypes, DepartmentEvaluationReport, ApprovalReport, EvaluationSummaryReport, OrderReleaseReport, POAReport } from '../../riskAssessments/riskAssessment/reporting/model';
import httpClient from './httpClient';

const createReportInternal = async (token: string, languageKey: string, reportType: string, tenantId: string, branchId: string, departmentId?: string, flowId?: string): Promise<Blob> => {
  const result = await httpClient.getInstance().post<Blob>(
    '/riskassessments/report',
    {
      token: token,
      languageKey,
      reportType,
      departmentId: departmentId || '0',
      flowId: flowId || '0',
    },
    { headers: { 'Content-Type': 'application/json', Accept: 'application/pdf' }, responseType: 'blob' },
  );

  return result.data;
};

const createReport = async (token: string, languageKey: string, reportData: RiskAssessmentReportTypes, tenantId: string, branchId: string) => {
  let report: Blob = null;
  if (reportData instanceof DepartmentEvaluationReport) {
    report = await createReportInternal(token, languageKey, reportData.reportType, tenantId, branchId, reportData.departmentId, '0');
  } else if (reportData instanceof ApprovalReport) {
    report = await createReportInternal(token, languageKey, reportData.reportType, tenantId, branchId, reportData.approvalStageId, reportData.flowId);
  } else if (reportData instanceof EvaluationSummaryReport) {
    report = await createReportInternal(token, languageKey, reportData.reportType, tenantId, branchId, '0', '0');
  } else if (reportData instanceof POAReport) {
    report = await createReportInternal(token, languageKey, reportData.reportType, tenantId, branchId, '0', reportData.flowId);
  } else if (reportData instanceof OrderReleaseReport) {
    report = await createReportInternal(token, languageKey, reportData.reportType, tenantId, branchId, '0', reportData.flowId);
  }

  return report;
};

export default {
  createReport,
};
